module.exports = __webpack_public_path__ + "img/ISO9001_UKAS.6659014b.png";